import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/SPM/SPRINGMASTERS_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const SPM_SITE_INFORMATION = [
  '1450 S. Buncombe Road',
  'Greer, SC 29651',
  'Phone (864) 877 - 5100',
  'Fax (864) 879 - 4518',
];

export function SPMQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo
          source={logo}
          text="ISO 9001:2015 Registered"
          // Extra styles can be added to fine tune the logo
          extraStyles={[{ height: '43px' }]}
        />

        <SiteInformation
          name="MW Components - Greer: Machined Products"
          items={SPM_SITE_INFORMATION}
        />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>FOB:</Text>
          <Text style={[styles.bold, styles.textSmall]}>
            Block Tolerances DO NOT APPLY to items on this quotation. Commercial
            tolerances per DIN 2089 will apply if not otherwise referenced on
            the drawing. We reserve the right to pass through increases in
            material, energy, freight and/or outside service cost in effect at
            the time of manufacture. Items ordered as part of a blanket or
            multiple release agreement must be taken with 12 months manufacture.
            Quoted delivery subject to material availability at time of order.
            DFAR items subject to material availability at time of order. To
            prevent any problems, parts not previously manufactured will have a
            quality assurance review prior to the start of production
          </Text>
        </View>
      </View>
    </Page>
  );
}
